import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import TaskRow from './TaskRow.jsx';
import { cn } from '@/lib/utils.js';

const SEVERITY_ACCENT = {
  overdue: 'text-accent',
  today: 'text-warning',
  week: 'text-text-muted',
  next_week: 'text-text-muted',
  later: 'text-text-muted',
};

const AUTO_EXPAND = new Set(['overdue', 'today']);

export default function TrafficBucket({ bucket, onMutate, forceExpand = false }) {
  const items = bucket?.items || [];
  const count = items.length;
  const headingClass = SEVERITY_ACCENT[bucket?.key] || 'text-text-muted';

  const shouldDefaultExpand = forceExpand || AUTO_EXPAND.has(bucket?.key) || count > 0;
  const [expanded, setExpanded] = useState(shouldDefaultExpand);

  return (
    <section className="space-y-2">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="flex w-full items-center justify-between border-b border-border pb-1.5 min-h-[44px]"
      >
        <div className="flex items-center gap-2">
          {expanded ? (
            <ChevronDown size={14} strokeWidth={1.5} className="text-text-dim" />
          ) : (
            <ChevronRight size={14} strokeWidth={1.5} className="text-text-dim" />
          )}
          <h2
            className={cn('text-xs font-semibold uppercase tracking-[0.14em]', headingClass)}
          >
            {bucket?.label}
          </h2>
        </div>
        <span className="font-mono text-[10px] text-text-dim">{count}</span>
      </button>
      {expanded ? (
        count === 0 ? (
          <p className="text-xs italic text-text-dim">Nothing here.</p>
        ) : (
          <div className="space-y-2">
            {items.map((item) => (
              <TaskRow key={item.zoho_task_id} item={item} onMutate={onMutate} />
            ))}
          </div>
        )
      ) : null}
    </section>
  );
}
